import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'

import { Logger, LoggerTypes } from '../../../../../../utils'
import { Button, buttonModes, buttonTypes, Icon, iconNames, AccessControl } from '../../../../../../components'
import { FlowElementConditionCard } from '../FlowElementConditionCard'
import { FlowElementConditionDialog } from '../FlowElementConditionDialog'
import { userRightTypes } from '../../../../../../constants'
import '../../../common-elements-style.scss'

export const FlowElementConditionCheckPanel = ({
  currentProject,
  currentScenario,
  currentFlowGroup,
  currentCondition,
  resources,
  variables,
  parameters
  // -- refresh after saving
  // refreshAfterSaving
}) => {
  const { t } = useTranslation()
  const [openDialog, setOpenDialog] = useState(false)

  const currentChecks = (currentCondition && currentCondition.checks) || null

  const onClickAddCondition = (e) => {
    e.stopPropagation()

    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementConditionInteractionResourcesPanel.onClickAddCondition()', {})

    setOpenDialog(!openDialog)
  }

  Logger.trace(LoggerTypes.CONTAINER, 'FlowElementConditionCheckPanel.render()', {
    currentCondition,
    currentChecks,
    resources,
    variables,
    parameters
  })

  return (
    <div className="FlowElementConditionCheckPanel">
      <div>
        <form>
          <Grid container spacing={2} style={{ padding: '10px', marginTop: '-4px' }}>
            {/*  Buttons [+ CONDITION]  */}
            <Grid item xs={12} sm={12} style={{ position: 'relative' }}>
              <AccessControl userPermissions={[userRightTypes.SCENARIO_ATTRIBUTES_EDIT]} renderNoAccess={() => <></>}>
                <div className="btCont">
                  <Button
                    mode={buttonModes.HEADER}
                    type={buttonTypes.BUTTON}
                    tooltip={t('flowActions.tasks.panels.interactions.resources.button_action.tooltip')}
                    onClick={onClickAddCondition}
                    icon={<Icon name={iconNames.PLUS} size={14} />}
                  />
                </div>
              </AccessControl>
              <div>
                {(currentChecks &&
                  currentChecks.map(
                    (check, index) =>
                      check && (
                        <FlowElementConditionCard
                          key={`condition-check-${index}`}
                          currentProject={currentProject}
                          currentScenario={currentScenario}
                          currentFlowGroup={currentFlowGroup}
                          currentCondition={currentCondition}
                          currentCheck={check}
                          // refreshAfterSaving={refreshAfterSaving}
                        />
                      )
                  )) || <i className="notFound">{t('flowActions.conditions.panels.not_found')}</i>}
              </div>
            </Grid>
          </Grid>
        </form>
        {openDialog && (
          <FlowElementConditionDialog
            currentProject={currentProject}
            currentScenario={currentScenario}
            currentFlowGroup={currentFlowGroup}
            currentCondition={currentCondition}
            resources={resources}
            variables={variables}
            parameters={parameters}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            // refreshAfterSaving={refreshAfterSaving}
          />
        )}
      </div>
    </div>
  )
}

FlowElementConditionCheckPanel.displayName = 'FlowElementConditionCheckPanel'

FlowElementConditionCheckPanel.propTypes = {
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object.isRequired,
  currentFlowGroup: PropTypes.object.isRequired,
  currentCondition: PropTypes.object,
  resources: PropTypes.arrayOf(PropTypes.object),
  variables: PropTypes.arrayOf(PropTypes.object),
  parameters: PropTypes.arrayOf(PropTypes.object)
  // -- refresh after saving
  // refreshAfterSaving: PropTypes.func
}

FlowElementConditionCheckPanel.defaultProps = {
  currentProject: null,
  currentScenario: null,
  currentFlowGroup: null,
  currentCondition: null,
  resources: [],
  variables: [],
  parameters: []
  // -- refresh after saving
  // refreshAfterSaving: null
}
